<table class="cp-table is-tight">
  <thead>
    <tr>
      <th
        *ngFor="let column of columns"
        class="{{ column }} center"
        [class.content-fit]="column === 'period'"
      >
        <div
          class="sort-label"
          (click)="column === 'issuedAt' ? onSortLabelClick(column) : null"
          [class.is-disabled]="
            column !== 'issuedAt' &&
            column !== 'issuedTo' &&
            column !== 'activatedBy'
          "
        >
          {{
            'common.bukTicketListComponent.tableHeaders.' + column | translate
          }}
          <ng-container
            *ngIf="column === 'issuedTo' || column === 'activatedBy'"
          >
            <app-filter
              *ngIf="
                (column === 'issuedTo' && issuedEmails?.length > 1) ||
                (column === 'activatedBy' && activatedEmails?.length > 1)
              "
              [items]="column === 'issuedTo' ? issuedEmails : activatedEmails"
              (action)="onAction($event, column)"
            ></app-filter>
          </ng-container>
          <mat-icon
            class="dropdown-icon icon-active"
            [class.is-hidden]="
              column === 'issuedTo' || column === 'activatedBy'
            "
            [class.is-rotated]="!isSortOrderDesc"
            >arrow_downward</mat-icon
          >
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let item of _items; let i = index"
      [class.is-expired]="item.isExpired && !item.activated_at"
    >
      <td
        *ngFor="let column of columns"
        class="{{ column }} center"
        [class.content-fit]="column === 'period'"
      >
        <ng-container
          *ngTemplateOutlet="
            {
              no: no,
              contentTitle: contentTitle,
              issuedAt: issuedAt,
              expiredAt: expiredAt,
              issuedTo: issuedTo,
              activatedBy: activatedBy,
              activatedAt: activatedAt,
              period: period,
              issuedCount: issuedCount,
              activatedCount: activatedCount,
              activatedRatio: activatedRatio,
              downloadURL: downloadURL
            }[column];
            context: { item: item, index: i }
          "
        >
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>
<ng-template #no let-item="item">{{ item.no }}</ng-template>
<ng-template #contentTitle let-item="item">
  <div>{{ item.content_title }}</div>
</ng-template>
<ng-template #issuedAt let-item="item">
  {{ item.issued_at | toDate | date: 'yyyy.MM.dd.' }}
</ng-template>
<ng-template #expiredAt let-item="item">
  {{ item.expired_at ? (item.expired_at | toDate | date: 'yyyy.MM.dd.') : '-' }}
</ng-template>
<ng-template #issuedTo let-item="item">
  {{ item.issued_to }}
</ng-template>
<ng-template #activatedBy let-item="item">
  {{ item.activated_by ? item.activated_by : '-' }}
</ng-template>
<ng-template #activatedAt let-item="item">
  {{
    item.activated_at ? (item.activated_at | toDate | date: 'yyyy.MM.dd.') : '-'
  }}
</ng-template>
<ng-template #period let-item="item">
  {{ item.period | periodTranslate }}
</ng-template>
<ng-template #issuedCount let-item="item">
  {{ item.issued_count }}
</ng-template>
<ng-template #activatedCount let-item="item">
  {{ item.activated_count }}
</ng-template>
<ng-template #activatedRatio let-item="item">
  {{ item.activated_ratio }}
</ng-template>
<ng-template #downloadURL let-item="item">
  <a mat-stroked-button color="primary" href="{{ item.download_url }}" download>
    {{ 'common.bukTicketListComponent.actions.download' | translate }}
  </a>
</ng-template>
